//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// suggestion-action-travel-ime imports
import { IContainer, IProps } from "./SuggestionActionTravelTime.d";
import { suggestionActionTravelTimeFragments } from "./SuggestionActionTravelTime.gql";
import { icon } from "./SuggestionActionTravelTime.styles";
// styles
import { palette } from "@clockwise/web-commons/src/styles/color.styles";
// other components
import { CardButton } from "@components/card";
// state
import { IReduxState } from "@reducers/root.reducer";
import { setSettingsDialogOpen } from "@actions/chrome-extension.actions";
import { toggleExpanded } from "@actions/settings.actions";
import { snackBarOpen } from "@actions/snack-bar.actions";
// util
// import { track, TrackingEvents } from '@util/analytics.util';
// assets
import { Room } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
class SuggestionActionSlackCmpt extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  // ~-~-~-~-~-~-~-
  // Click Handlers
  // ~-~-~-~-~-~-~-
  private onOpenSettings = () => {
    this.props.setSettingsDialogOpen(true);
    this.props.toggleExpanded("expandTravelTime");
  };

  // ~-~-~-~-~-~-~-
  // Rendering
  // ~-~-~-~-~-~-~-
  // helper for assembling the buttons
  private renderBtn = (label: string, action?: () => void, icon?: JSX.Element) => {
    return (
      <CardButton
        label={label}
        textColor={palette.white}
        onClick={() => action && action()}
        icon={icon}
        style={icon ? {} : { width: "inherit", display: "inline-block" }}
        flat
        isIconHTMLElement
      />
    );
  };

  // primary rendering
  public render() {
    const { height, width, ...styles } = icon;
    const iconComponent = (
      <Room height={height} width={width} style={styles} htmlColor={palette.white} />
    );

    return (
      <div>{this.renderBtn("Set Your Work Location", this.onOpenSettings, iconComponent)}</div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

export const SuggestionActionTravelTime_redux = connect(mapStateToProps, {
  setSettingsDialogOpen,
  snackBarOpen,
  toggleExpanded,
})(SuggestionActionSlackCmpt);

//////////////////
// RELAY
//////////////////
export const SuggestionActionTravelTime = createFragmentContainer<IContainer>(
  SuggestionActionTravelTime_redux,
  suggestionActionTravelTimeFragments,
);
